import { getMarketingLanguageFromPath } from "../../marketing-content/marketingLocales";
import React, { useCallback } from "react";
import { trackMarketingSitePageView } from "../../utils/analytics/marketing-site-screen-view";
import { Link as RouterLink } from "react-router-dom";
import { MarketingPageMain, MarketingSiteShell } from "./MarketingSiteShell";
import { getMarketingHomeRoute, getMarketingSiteCopy } from "./marketingSiteCopy";
import { MarketingDocumentHead } from "./MarketingDocumentHead";

export const getMarketingPageLanguageFromPathname = getMarketingLanguageFromPath;

/** The marketing site's "page not found": the shell (nav, footer, theme) around a short message. */
export const MarketingNotFoundPage = React.memo(function MarketingNotFoundPage({ pathname }: { pathname: string }) {
  const lang = getMarketingPageLanguageFromPathname(pathname);
  const copy = getMarketingSiteCopy(lang);
  const reportPageView = useCallback(
    () =>
      trackMarketingSitePageView({
        pageViewEventName: "Marketing Page Viewed",
        pageViewEventProperties: { route: pathname, section: null, template: "notFound", lang },
      }),
    [pathname, lang]
  );
  return (
    <MarketingSiteShell lang={lang}>
      <MarketingDocumentHead language={lang} onChangeClientState={reportPageView}>
        <title>{copy.notFoundDocumentTitle}</title>
        <meta name="robots" content="noindex" />
      </MarketingDocumentHead>
      <MarketingPageMain template="article">
        <article className="marketing-article">
          <h1 className="marketing-article-heading">{copy.pageNotFoundTitle}</h1>
          <div className="marketing-article-body">
            <p>{copy.pageNotFoundBody}</p>
            <p>
              <RouterLink to={getMarketingHomeRoute(lang)}>{copy.pageNotFoundHomeLink}</RouterLink>
            </p>
          </div>
        </article>
      </MarketingPageMain>
    </MarketingSiteShell>
  );
});
